import React from 'react';
import { Button } from '@ihsm/ui-shared';
import { TransparentButton } from 'shared/components/Buttons';
import { Modal } from 'shared/components/modal';
import './ConfirmExitModal.scss';

export interface ConfirmExitModalProps {
  isVisible: boolean;
  setVisibility: (value: boolean) => void;
  onConfirm: () => void;
}

export const ConfirmExitModal: React.FC<ConfirmExitModalProps> = ({
  isVisible,
  onConfirm,
  setVisibility,
}) => (
  <Modal
    className="confirm-exit-modal"
    isVisible={isVisible}
    setVisibility={setVisibility}
  >
    <h3 className="confirm-exit-modal__title">Exit Editor?</h3>
    <div className="confirm-exit-modal__message">
      Any unsaved changes made to this configuration will be lost.
    </div>
    <div className="confirm-exit-modal__button-area">
      <TransparentButton
        text="Continue Editing"
        onClick={() => setVisibility(false)}
      />
      <Button text="Exit Editor" onClick={onConfirm} />
    </div>
  </Modal>
);
